import {
    Component, Input, ViewChild, Output, EventEmitter, AfterViewInit,
    OnChanges, SimpleChanges
} from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';

import { ScriptLoaderService } from './../../_services';
@Component({
    selector: 'app-select',
    templateUrl: './select.component.html'
})

export class SelectComponent implements AfterViewInit {
    @Input() elements: any[];
    @Input() element: any;
    @Input() texts = {
        label: "",
        notFound: "Resultados no encontrados",
        loading: "Cargando...",
        none: "Ninguno"
    }
    @ViewChild('select') select;
    @Output() selected = new EventEmitter();
    constructor(private _script: ScriptLoaderService, private _sanitizer: DomSanitizer) { }

    ngOnChanges(changes: SimpleChanges) {
        if ('element' in changes) {
            let element = changes['element'].currentValue;
            if (element) {
                this.element = element;
                this.refreshList();
            }
        }
    }

    ngAfterViewInit() {
        this._script.loadScripts('app-select',
            ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-select.js']);
        $(this.select.nativeElement).on('changed.bs.select', (e) => {
            let idx = Number(($(this.select.nativeElement) as any).selectpicker('val'));
            if (this.elements.length) {
                this.element = this.elements[idx];
                this.selected.emit(this.element);
            }
        });
        this.refreshList();
    }

    protected getOptions() {
        let options = '';
        this.elements.forEach((el, idx) => {
            options = `${options}<option value="${idx}">${el}</option>`;
        });
        return (this._sanitizer.bypassSecurityTrustHtml(options) as any)
            .changingThisBreaksApplicationSecurity;
    }

    protected find() {
        let index = -1;
        this.elements.forEach((el, idx) => {
            if (el.id == this.element.id) {
                index = idx;
            }
        });
        return index;
    }

    refreshList() {
        ($(this.select.nativeElement) as any).html(this.getOptions()).selectpicker('refresh');
        ($(this.select.nativeElement) as any).selectpicker('val', -1);
        if (this.element) {
            let idx = this.find();
            if (idx != -1) ($(this.select.nativeElement) as any).selectpicker('val', idx);
        }
    }

    clear() {
        ($(this.select.nativeElement) as any).selectpicker('val', -1);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/select/select.component.ts